import { SET_ENTRY_SIGNAL, type EntrySignalPayload } from 'stash/actions/entrySignal';

export type EntrySignalState = {
	theme?: string;
	channel?: string;
	promoCode?: string;
	mixName?: string;
	prompt?: string;
	/** Intro to Financial Advisor onboarding intent: retirement or invest. */
	intent?: string;
};

type EntrySignalAction = {
	type: typeof SET_ENTRY_SIGNAL;
	payload: EntrySignalPayload;
};

const entrySignal = (state: EntrySignalState = {}, action: EntrySignalAction): EntrySignalState => {
	switch (action.type) {
		case SET_ENTRY_SIGNAL:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default entrySignal;
